module.exports = __webpack_public_path__ + "img/ly.050a225a.svg";